import Service from "../../services";

const state = {}

const actions = {
    getOrderByRef({
        commit
    }, ref) {
        return Service.Order.get(ref).then(res => {
            return res
        })
    },
    getOrderPayment({
        commit
    }, orderId) {
        return Service.Order.getPayment(orderId).then(res => {
            return res
        })
    },
    getOrderDriver({
        commit
    }, orderId) {
        return Service.Order.getDriver(orderId).then(res => {
            return res
        })
    },
}

const getters = {}
const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
